import React from "react";
import {
  OPERATOR_ADD_PATH,
  OPERATOR_UPDATE_PATH,
  OPERATORS_PATH,
} from "utils/constants/paths";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";

const Operators = Loadable(React.lazy(() => import("./View")));
const OperatorsAddOrUpdate = Loadable(
  React.lazy(() => import("./View/Detail"))
);

export const OperatorsRoute: IRouteItem = {
  path: OPERATORS_PATH,
  iconName: "People",
  element: React.createElement(Operators),
  name: "Operators",
  accessKeys: ["SuperAdmin", "Admin", "Manager"],
  children: [
    {
      name: "Add / Update",
      path: OPERATOR_ADD_PATH,
      element: React.createElement(OperatorsAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: OPERATOR_UPDATE_PATH,
      element: React.createElement(OperatorsAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
